const state = {
  alertsTop: [],
  alertsBottom: [],
  alertsId: 0
}

const actions = {
  addAlert ({ state }, alert) {
    const id = state.alertsId++
    if (alert.pos === 'bottom') {
      state.alertsBottom.push({ id, alert })
      return
    }
    state.alertsTop.push({ id, alert })
  },
  removeAlert ({ state }, id) {
    state.alertsTop = state.alertsTop.filter(m => m.id !== id)
    state.alertsBottom = state.alertsBottom.filter(m => m.id !== id)
  },
  addSomethingWrongAlert ({ dispatch }, text) {
    dispatch('addAlert', {
      type: 'danger',
      text: text || 'Что-то пошло не так. Попробуйте снова',
      pos: 'bottom',
      noButton: true,
      noIcon: true
    })
  },
  addSuccessAlert ({ dispatch }, text) {
    dispatch('addAlert', {
      type: 'success',
      text: text,
      pos: 'bottom',
      button: { name: '' },
      noIcon: true
    })
  }
}

export const alerts = {
  namespaced: true,
  state,
  actions
}
